/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AnalyticsTimeseriesDto } from '../../models/analytics-timeseries-dto';

export interface SuperadminControllerGetAnalyticsTimeseries$Params {
  from?: string;
  to?: string;
  event?: 'registration_start' | 'registration_completed' | 'paywall_shown' | 'upgrade_modal_opened' | 'checkout_started' | 'checkout_failed' | 'purchase_completed' | 'subscription_canceled';
}

export function superadminControllerGetAnalyticsTimeseries(http: HttpClient, rootUrl: string, params?: SuperadminControllerGetAnalyticsTimeseries$Params, context?: HttpContext): Observable<StrictHttpResponse<AnalyticsTimeseriesDto>> {
  const rb = new RequestBuilder(rootUrl, superadminControllerGetAnalyticsTimeseries.PATH, 'get');
  if (params) {
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('event', params.event, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AnalyticsTimeseriesDto>;
    })
  );
}

superadminControllerGetAnalyticsTimeseries.PATH = '/superadmin/analytics/timeseries';
